<template>
  <div id="app">
    <header>
      <div class="navigation" :class="{ hide: !debug}">
        <!-- <div class="small-btn" @click="reset">Reset</div> -->
        <router-link class="small-btn" to="/sim">Sim</router-link>
        <router-link class="small-btn" to="/data">Data</router-link>
        <!-- <span class="debug">Debug:</span> -->
      </div>
      
      <div class="logo-header" @click="toggleDispatch()">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 516.744 91.817" enable-background="new 0 0 516.744 91.817" xml:space="preserve">
          <g>
            <path id="letter1" fill="#FFFFFF" d="M0,10.066c0-1.174,0.223-2.278,0.671-3.313C1.118,5.718,1.733,4.81,2.517,4.026
              c0.782-0.782,1.69-1.397,2.726-1.845C6.277,1.734,7.382,1.51,8.556,1.51s2.278,0.224,3.313,0.671
              c1.034,0.448,1.942,1.063,2.726,1.845c0.783,0.784,1.397,1.692,1.845,2.726c0.447,1.036,0.671,2.139,0.671,3.313
              s-0.224,2.279-0.671,3.313c-0.448,1.036-1.062,1.944-1.845,2.726c-0.784,0.784-1.692,1.398-2.726,1.846
              c-1.035,0.448-2.139,0.671-3.313,0.671s-2.279-0.223-3.313-0.671c-1.036-0.447-1.944-1.062-2.726-1.846
              c-0.784-0.782-1.398-1.69-1.845-2.726C0.223,12.345,0,11.24,0,10.066z M16.189,26.59v43.03H1.007V26.59H16.189z"/>
            <path id="letter2" fill="#FFFFFF" d="M26.59,26.59h15.182v5.452c2.068-2.517,4.165-4.207,6.291-5.075
              c2.125-0.867,4.613-1.3,7.465-1.3c3.02,0,5.605,0.49,7.759,1.468c2.152,0.979,3.984,2.363,5.494,4.152
              c1.229,1.455,2.068,3.076,2.517,4.865c0.447,1.791,0.671,3.831,0.671,6.124v27.345H56.787V47.896c0-2.125-0.155-3.844-0.461-5.159
              c-0.308-1.313-0.853-2.361-1.636-3.146c-0.671-0.671-1.426-1.145-2.265-1.426c-0.839-0.279-1.734-0.419-2.684-0.419
              c-2.573,0-4.544,0.77-5.914,2.307c-1.371,1.539-2.055,3.733-2.055,6.585v22.983H26.59V26.59z"/>
            <path id="letter3" fill="#FFFFFF" d="M110.804,37.662c-2.797-1.453-5.536-2.181-8.22-2.181c-1.398,0-2.531,0.28-3.397,0.839
              c-0.868,0.56-1.3,1.314-1.3,2.265c0,0.503,0.069,0.91,0.209,1.216c0.139,0.308,0.447,0.602,0.923,0.881
              c0.475,0.28,1.174,0.532,2.097,0.755c0.922,0.224,2.139,0.503,3.648,0.839c4.194,0.839,7.325,2.335,9.395,4.487
              c2.068,2.153,3.104,4.907,3.104,8.262c0,2.517-0.503,4.781-1.51,6.794c-1.007,2.013-2.405,3.705-4.194,5.075
              c-1.79,1.371-3.942,2.433-6.458,3.188c-2.517,0.755-5.285,1.132-8.304,1.132c-5.817,0-11.548-1.649-17.195-4.949l5.536-10.737
              c4.25,2.908,8.275,4.362,12.079,4.362c1.397,0,2.544-0.307,3.439-0.923c0.894-0.615,1.342-1.397,1.342-2.349
              c0-0.558-0.071-1.02-0.21-1.384c-0.14-0.363-0.434-0.699-0.881-1.007c-0.448-0.307-1.104-0.587-1.971-0.839
              c-0.868-0.251-2-0.516-3.397-0.797c-4.697-0.95-7.983-2.361-9.856-4.236c-1.874-1.873-2.81-4.458-2.81-7.759
              c0-2.404,0.447-4.571,1.342-6.501c0.894-1.929,2.181-3.564,3.858-4.907s3.704-2.376,6.082-3.104c2.376-0.726,5.018-1.09,7.926-1.09
              c4.752,0,9.366,0.922,13.84,2.768L110.804,37.662z"/>
            <path id="letter4" fill="#FFFFFF" d="M123.972,10.066c0-1.174,0.223-2.278,0.671-3.313c0.447-1.034,1.062-1.942,1.845-2.726
              c0.782-0.782,1.69-1.397,2.726-1.845c1.034-0.447,2.139-0.671,3.313-0.671s2.278,0.224,3.313,0.671
              c1.034,0.448,1.942,1.063,2.726,1.845c0.783,0.784,1.397,1.692,1.845,2.726c0.447,1.036,0.671,2.139,0.671,3.313
              s-0.224,2.279-0.671,3.313c-0.448,1.036-1.062,1.944-1.845,2.726c-0.784,0.784-1.692,1.398-2.726,1.846
              c-1.035,0.448-2.139,0.671-3.313,0.671s-2.279-0.223-3.313-0.671c-1.036-0.447-1.944-1.062-2.726-1.846
              c-0.784-0.782-1.398-1.69-1.845-2.726C124.195,12.345,123.972,11.24,123.972,10.066z M140.161,26.59v43.03h-15.182V26.59H140.161z"
              />
            <path id="letter5" fill="#FFFFFF" d="M198.708,26.59v40.094c0,2.405-0.14,4.557-0.419,6.459c-0.28,1.9-0.671,3.578-1.174,5.033
              c-0.671,1.846-1.719,3.565-3.146,5.159c-1.426,1.594-3.146,2.978-5.159,4.152s-4.292,2.097-6.836,2.768
              c-2.545,0.671-5.299,1.007-8.262,1.007c-3.355,0-6.431-0.419-9.227-1.258c-2.797-0.839-5.242-2-7.339-3.481
              c-2.097-1.482-3.816-3.216-5.159-5.201c-1.342-1.985-2.237-4.152-2.684-6.5h17.111c1.062,2.852,3.467,4.278,7.214,4.278
              c3.188,0,5.633-0.895,7.339-2.684c1.705-1.791,2.559-4.278,2.559-7.465v-4.11c-1.119,1.063-2.195,1.944-3.229,2.642
              c-1.035,0.7-2.084,1.273-3.146,1.72c-1.063,0.447-2.181,0.768-3.355,0.965c-1.174,0.195-2.461,0.293-3.859,0.293
              c-3.076,0-5.9-0.532-8.472-1.594c-2.573-1.062-4.795-2.544-6.668-4.446c-1.874-1.9-3.328-4.18-4.362-6.836
              c-1.035-2.655-1.552-5.605-1.552-8.85c0-3.299,0.558-6.36,1.678-9.185c1.118-2.823,2.642-5.285,4.571-7.382
              s4.222-3.746,6.878-4.949c2.655-1.202,5.549-1.803,8.681-1.803c5.088,0,9.366,1.901,12.834,5.704v-4.53H198.708z M164.653,47.896
              c0,1.398,0.251,2.699,0.755,3.9c0.503,1.203,1.188,2.252,2.055,3.146c0.866,0.896,1.9,1.594,3.104,2.097
              c1.202,0.503,2.502,0.755,3.9,0.755c1.342,0,2.613-0.251,3.816-0.755c1.202-0.503,2.236-1.202,3.104-2.097
              c0.866-0.894,1.565-1.942,2.097-3.146c0.531-1.202,0.797-2.474,0.797-3.816c0-1.397-0.266-2.684-0.797-3.858
              c-0.532-1.174-1.245-2.208-2.139-3.104c-0.895-0.894-1.943-1.594-3.146-2.097s-2.447-0.755-3.732-0.755
              c-1.342,0-2.601,0.266-3.775,0.797c-1.174,0.532-2.209,1.231-3.104,2.097c-0.895,0.868-1.608,1.887-2.139,3.062
              C164.918,45.295,164.653,46.554,164.653,47.896z"/>
            <path id="letter6" fill="#FFFFFF" d="M209.025,0h15.182v32.042c2.068-2.517,4.165-4.207,6.291-5.075
              c2.125-0.867,4.613-1.3,7.465-1.3c5.423,0,9.521,1.497,12.289,4.488c2.768,2.992,4.152,7.033,4.152,12.121v27.345h-15.182V47.896
              c0-2.181-0.168-3.942-0.503-5.284s-0.895-2.376-1.678-3.104c-1.342-1.174-2.964-1.762-4.865-1.762c-2.573,0-4.544,0.77-5.914,2.307
              c-1.371,1.539-2.055,3.733-2.055,6.585v22.983h-15.182L209.025,0L209.025,0z"/>
            <path id="letter7" fill="#FFFFFF" d="M281.664,39.256v30.365h-15.183V39.256h-5.033V26.59h5.033V13.673h15.183V26.59h8.64v12.666
              H281.664z"/>
          </g>
          <g>
            <path id="letter8" fill="#4DE5C1" d="M348.901,10.143l-3.994,13.928h8.04l-0.871,3.226h-7.988l-8.807,30.211
              c-0.956,3.244-1.434,5.343-1.434,6.299c0,0.581,0.136,1.024,0.41,1.331c0.273,0.307,0.597,0.461,0.973,0.461
              c0.853,0,1.979-0.597,3.379-1.792c0.819-0.683,2.646-2.782,5.479-6.299l1.69,1.28c-3.141,4.575-6.111,7.801-8.91,9.678
              c-1.913,1.297-3.841,1.946-5.787,1.946c-1.502,0-2.731-0.47-3.687-1.408c-0.957-0.938-1.434-2.142-1.434-3.61
              c0-1.844,0.546-4.66,1.639-8.449l8.551-29.648h-7.732l0.512-1.997c3.755-1.024,6.878-2.552,9.371-4.583
              c2.492-2.031,5.274-5.556,8.347-10.574C346.648,10.143,348.901,10.143,348.901,10.143z"/>
            <path id="letter9" fill="#4DE5C1" d="M399.289,38.87c0,5.121-1.357,10.19-4.071,15.208c-2.714,5.018-6.496,8.996-11.342,11.931
              c-4.848,2.937-9.559,4.404-14.133,4.404c-4.677,0-8.492-1.493-11.444-4.48c-2.954-2.987-4.43-6.853-4.43-11.599
              c0-5.018,1.442-10.053,4.327-15.106c2.884-5.052,6.742-9.046,11.573-11.982c4.83-2.936,9.499-4.404,14.005-4.404
              s8.219,1.485,11.137,4.455C397.83,30.267,399.289,34.125,399.289,38.87z M390.789,35.336c0-3.175-0.777-5.607-2.33-7.297
              c-1.554-1.69-3.559-2.535-6.017-2.535c-5.018,0-9.636,3.593-13.851,10.779c-4.217,7.187-6.324,14.33-6.324,21.43
              c0,3.244,0.819,5.744,2.458,7.501c1.639,1.759,3.704,2.637,6.196,2.637c4.813,0,9.328-3.576,13.544-10.728
              C388.68,49.974,390.789,42.71,390.789,35.336z"/>
            <path id="letter10" fill="#4DE5C1" d="M470.455,26.017l-1.486,5.325h-8.551c0.648,1.844,0.973,3.568,0.973,5.172
              c0,4.506-1.912,8.518-5.734,12.034c-3.859,3.517-9.15,5.462-15.875,5.837c-3.619,1.093-6.333,2.39-8.142,3.892
              c-0.683,0.547-1.024,1.11-1.024,1.69c0,0.684,0.307,1.306,0.921,1.869c0.615,0.563,2.167,1.135,4.66,1.715l9.934,2.304
              c5.496,1.298,9.133,2.834,10.908,4.609c1.74,1.809,2.611,3.892,2.611,6.247c0,2.799-1.033,5.359-3.1,7.681
              c-2.064,2.321-5.086,4.139-9.062,5.453c-3.977,1.314-8.373,1.972-13.186,1.972c-4.233,0-8.09-0.504-11.572-1.511
              s-5.975-2.364-7.477-4.071C413.752,84.527,413,82.77,413,80.961c0-1.468,0.486-2.996,1.459-4.583
              c0.973-1.587,2.193-2.893,3.661-3.917c0.922-0.649,3.533-2.185,7.834-4.609c-1.57-1.229-2.355-2.577-2.355-4.045
              c0-1.365,0.691-2.816,2.074-4.353c1.382-1.537,4.309-3.226,8.782-5.07c-3.756-0.717-6.733-2.287-8.936-4.711
              c-2.202-2.423-3.303-5.121-3.303-8.09c0-4.847,2.125-9.183,6.375-13.007c4.25-3.823,9.909-5.735,16.976-5.735
              c2.561,0,4.66,0.256,6.299,0.768s3.225,1.314,4.762,2.407h13.827V26.017z M428.157,69.184c-2.765,1.263-4.856,2.884-6.273,4.865
              c-1.417,1.979-2.125,3.925-2.125,5.837c0,2.253,1.024,4.113,3.072,5.582c2.936,2.116,7.237,3.175,12.904,3.175
              c4.881,0,9.055-0.828,12.52-2.483c3.465-1.656,5.197-3.798,5.197-6.427c0-1.331-0.639-2.595-1.92-3.789
              c-1.279-1.195-3.764-2.168-7.451-2.919C442.068,72.615,436.76,71.335,428.157,69.184z M452.685,34.057
              c0-2.731-0.76-4.882-2.279-6.452c-1.52-1.57-3.508-2.355-5.965-2.355c-3.858,0-7.041,1.938-9.55,5.812
              c-2.509,3.875-3.764,7.911-3.764,12.11c0,2.629,0.802,4.78,2.407,6.452c1.604,1.673,3.55,2.509,5.838,2.509
              c1.81,0,3.56-0.495,5.249-1.485s3.115-2.355,4.275-4.097s2.082-3.959,2.766-6.657C452.343,37.198,452.685,35.252,452.685,34.057z"
              />
            <path id="letter11" fill="#4DE5C1" d="M516.744,38.87c0,5.121-1.356,10.19-4.07,15.208s-6.495,8.996-11.343,11.931
              c-4.848,2.937-9.559,4.404-14.133,4.404c-4.678,0-8.492-1.493-11.444-4.48c-2.953-2.987-4.43-6.853-4.43-11.599
              c0-5.018,1.442-10.053,4.327-15.106c2.885-5.052,6.741-9.046,11.572-11.982c4.83-2.936,9.499-4.404,14.005-4.404
              c4.507,0,8.219,1.485,11.138,4.455C515.285,30.267,516.744,34.125,516.744,38.87z M508.244,35.336c0-3.175-0.776-5.607-2.33-7.297
              s-3.559-2.535-6.017-2.535c-5.019,0-9.636,3.593-13.852,10.779c-4.216,7.187-6.323,14.33-6.323,21.43
              c0,3.244,0.819,5.744,2.457,7.501c1.639,1.759,3.704,2.637,6.196,2.637c4.813,0,9.328-3.576,13.544-10.728
              C506.135,49.974,508.244,42.71,508.244,35.336z"/>
          </g>
        </svg>
      </div>
    </header>
    <div class="content">
      <router-view />
    </div>

    <transition name="fade">
      <footer v-if="isRegister">
        <p>© 2021 Insight Experience</p>
        <p><strong>BUILD</strong> {{version}}</p>
      </footer>
    </transition>

    <div class="gradientBackground">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1125 2436" enable-background="new 0 0 1125 2436" preserveAspectRatio="none">
        <g>
          <defs>
            <rect id="SVGID_1_" width="1124.5" height="2435.5"/>
          </defs>
          <clipPath id="SVGID_2_">
            <use xlink:href="#SVGID_1_"  overflow="visible"/>
          </clipPath>
          <linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="822.7556" y1="44.0812" x2="299.1512" y2="2405.8713">
            <stop  offset="0.1054" style="stop-color:#0E2B3C"/>
            <stop  offset="1" style="stop-color:#70808A"/>
          </linearGradient>
          <rect clip-path="url(#SVGID_2_)" fill="url(#SVGID_3_)" width="1125" height="2436"/>
          
            <radialGradient id="SVGID_4_" cx="-20.4572" cy="2453.9578" r="1805.6998" fx="-365.5092" fy="2470.2683" gradientUnits="userSpaceOnUse">
            <stop  offset="0.0738" style="stop-color:#0E2B3C"/>
            <stop  offset="0.9173" style="stop-color:#0E2B3C;stop-opacity:0"/>
          </radialGradient>
          <polygon clip-path="url(#SVGID_2_)" fill="url(#SVGID_4_)" points="0,0 1125,0 1125,2436 0,2436 	"/>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { format } from 'date-fns'
import { gsap } from '/src/assets/js/gsap';
import store from "@/store";

export default {
  name: "App",
  data: function () {
    return {
      letters: ['#letter1, #letter2, #letter3, #letter4, #letter5, #letter6, #letter7, #letter8, #letter9, #letter10, #letter11']
    };
  },
  methods: {
    ...mapActions(["reset"]),
    appHeight () {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
      doc.style.setProperty('--content-height', `${window.innerHeight - 100}px`)
    },
    toggleDispatch() {
      store.dispatch("toggleDebug");
    }
  },
  computed: {
    debug() {
      return this.$store.state.debug
    },
    version() {
      return format(new Date(Number(this.$store.state.version )), 'M/d/yy p')
    },
    isRegister() {
      return this.$route.name === "register"
    }
  },
  mounted () {
    window.addEventListener('resize', this.appHeight)
    this.appHeight;

    // only animate if on registration/home
    if(this.isRegister) {
      const tl = new gsap.timeline();
      tl.set(this.letters, { autoAlpha: 0});
      tl.set('footer p', { autoAlpha: 0});
      tl.set('.logo-header', {scale: 1.6, xPercent:-50, yPercent:-50, left:"50%", top:"50%", position: 'absolute'}, "+=.2")
      tl.set('.logo-header', { autoAlpha: 1})
      tl.from(this.letters, { stagger: { amount: 0.5}, autoAlpha: 0})
      tl.to('.logo-header', { xPercent:-50, yPercent:0, left:"50%", top:"0", position:"absolute", scale: 1, ease: 'power2.out', duration: 0.75})
      tl.from('footer p', { stagger: { amount: 0.25}, autoAlpha: 0}, 1)
      
    }
  }
};
</script>

